import React, { useState, forwardRef } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * Drop-in replacement for <input type="password"> that adds a show/hide toggle.
 * Forwards all input props (value, onChange, onFocus, onBlur, placeholder,
 * className, autoComplete, required, disabled, id, name, ref, …). The caller's
 * `style` is preserved; margin/width are lifted onto the wrapper so the eye icon
 * stays vertically centred over the field.
 */
const PasswordInput = forwardRef(({ style, iconColor = "#5D635F", ...props }, ref) => {
  const [visible, setVisible] = useState(false);

  const { width, margin, marginTop, marginBottom, ...inputStyle } = style || {};

  return (
    <div style={{ position: "relative", width: width ?? "100%", margin, marginTop, marginBottom }}>
      <input
        ref={ref}
        {...props}
        type={visible ? "text" : "password"}
        style={{ ...inputStyle, width: "100%", paddingRight: 40, boxSizing: "border-box" }}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setVisible(v => !v)}
        aria-label={visible ? "Hide password" : "Show password"}
        title={visible ? "Hide password" : "Show password"}
        style={{
          position: "absolute",
          right: 8,
          top: "50%",
          transform: "translateY(-50%)",
          background: "transparent",
          border: "none",
          padding: 4,
          margin: 0,
          cursor: "pointer",
          color: iconColor,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          lineHeight: 0,
        }}
      >
        {visible ? <EyeOff size={16} /> : <Eye size={16} />}
      </button>
    </div>
  );
});

PasswordInput.displayName = "PasswordInput";

export default PasswordInput;
